module.exports = __webpack_public_path__ + "img/section07-img01.3ea020d3.png";